import { render, staticRenderFns } from "./Ref2.vue?vue&type=template&id=620fd8a6&"
import script from "./Ref2.vue?vue&type=script&lang=js&"
export * from "./Ref2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports